import { render } from "./B2CContactPopup.vue?vue&type=template&id=7852a084&lang=pug"
import script from "./B2CContactPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./B2CContactPopup.vue?vue&type=script&setup=true&lang=js"

import "./B2CContactPopup.vue?vue&type=style&index=0&id=7852a084&lang=sass"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__